import Highcharts from 'highcharts/js/highstock';

require('highcharts/js/highcharts-more')(Highcharts);
require('highcharts/js/modules/no-data-to-display')(Highcharts);

Highcharts.setOptions({
    global: {
        useUTC: false
    }
});

/** @ngInject */
export default function chartDirectiveConfig($timeout, EventEmitter) {
    function link($scope, $element, $attrs, $ctrl) {
        const elementNode = $element[0];
        $ctrl.chart = Highcharts[$ctrl.useStockChart ? 'StockChart' : 'chart'](elementNode, $ctrl.config);

        $ctrl.onChartLoaded(
            EventEmitter({ // eslint-disable-line new-cap
                chart: $ctrl.chart
            })
        );

        $timeout(() => {
            $ctrl.chart.reflow();
        }, 100);
    }

    class controller {
        $onChanges(changes) {
            if (changes.config && !changes.config.isFirstChange()) {
                // TODO: introduce check of the whole config not just updating the data
                const { series } = changes.config.currentValue;
                series.forEach(({ data }, index) => {
                    this.chart.series[index].setData(data);
                });
            }
        }
    }

    return {
        restrict: 'E',
        template: '<div class="chart-container"></div>',
        scope: {
            onChartLoaded: '&',
            config: '<',
            useStockChart: '<'
        },
        bindToController: true,
        link,
        controller
    };
}



// WEBPACK FOOTER //
// ./app/common/chart/chart.directive.js